import { Component, Input, OnInit } from '@angular/core';
import { ServiceRequestService } from '../../../../services/servicerequest.service'

@Component({
  selector: 'app-custom-question-responses',
  templateUrl: './custom-question-responses.component.html',
  styleUrls: ['./custom-question-responses.component.scss']
})
export class CustomQuestionResponsesComponent implements OnInit {

  @Input() jobcard : any = {};
  @Input() partnerID : any = {};
  public customQuestionResponses : any = [];
  public editQuestions : boolean = false;
  public loadingCustomQuestions : boolean = false;
  public busySaving : boolean = false;

  constructor(
    private serviceRequest : ServiceRequestService
  ) { }

  ngOnInit() {
    this.getCustomQustions();
  }

  getCustomQustions(){
    this.loadingCustomQuestions = true;
    this.serviceRequest.getServiceCustomQuestions(this.partnerID, this.jobcard.ID).subscribe((response : any)=>{
      this.customQuestionResponses = response;
      this.loadingCustomQuestions = false;
    },err=>{
      this.loadingCustomQuestions = false;
    });
  }

  updateQuestionResponses(){
    this.busySaving = true;
    this.serviceRequest.updateServiceCustomQuestionResponses(this.partnerID, this.jobcard.ID, this.customQuestionResponses).subscribe((response)=>{
      this.customQuestionResponses = response;
      this.busySaving = false;
      this.editQuestions = false;
    });
  }

}
